<template>
  <div class="rt-button-group">
    <slot />
    <div v-if="$slots.more" class="button-group-more">
      <el-popover
        slot="more"
        ref="popover"
        trigger="hover"
        popper-class="rtElPopover"
      >
        <div slot="reference" class="rt-button-more">
          <rt-button icon-name="rt-base-more" />
        </div>
        <div class="rt-button-group-popper-wrapper"><slot name="more" /></div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import RtButton from './rtButton';
export default {
  name: 'RtButtonGroup',
  components: {
    RtButton
  }
};
</script>



// WEBPACK FOOTER //
// rtButtonGroup.vue?0c75d2f5